// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.sles-container {
  border-radius: 5px;
  margin: 16px 0px 32px 0px;
  min-height: 300px;
}
.sles-container .ordinal-movement-wrapper {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.sles-container .sle-and-children {
  border-radius: 5px;
  background-color: #D1D3D4;
  margin: 24px 0px;
  padding: 4px;
}
.sles-container .sle-and-children .sle-wrapper {
  align-items: center;
  display: flex;
  margin: 16px 8px;
}
.sles-container .sle-and-children .sle-wrapper label {
  font-size: 20px;
  font-weight: 500;
}
.sles-container .sle-and-children .sle-wrapper .sle-text-area {
  border-radius: 5px;
  font-size: 14px;
  margin-left: 16px;
  max-height: 80px;
  min-height: 30px;
  padding: 8px;
  resize: vertical;
  width: 90%;
}
.sles-container .sle-and-children .sle-child-wrapper {
  align-items: center;
  display: flex;
  margin: 4px 39px 4px 80px;
}
.sles-container .sle-and-children .sle-child-wrapper label {
  font-size: 16px;
  font-weight: 500;
}
.sles-container .sle-and-children .sle-child-wrapper .sle-child-text-area {
  border-radius: 5px;
  font-size: 14px;
  margin-left: 8px;
  max-height: 80px;
  padding: 8px;
  resize: vertical;
  width: 93%;
}
.sles-container .icon-btn-wrapper {
  border-radius: 5px;
  align-items: flex-start;
  background-color: #0669B3;
  display: flex;
  height: 30px;
  margin-left: 16px;
  padding-top: 1px;
}
.sles-container .button-icon-right {
  background-color: transparent;
  border: none;
}
.sles-container .button-icon {
  background-color: transparent;
  border: none;
}

.sle-button-wrapper {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.copy-or-create-container {
  align-items: flex-start;
  display: flex;
  gap: 20px;
  justify-content: center;
  min-height: 132px;
  padding: 32px 20px;
}
.copy-or-create-container .card {
  border-radius: 10px;
  background: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 16px;
  text-align: center;
  transition: 0.2s;
  width: 45%;
}
.copy-or-create-container .card .card-body .card-title {
  color: #0669B3;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 12px;
}
.copy-or-create-container .card .card-body .form-select {
  border-radius: 5px;
  border: 1px solid #808080;
  color: #444343;
  padding: 4px;
}
.copy-or-create-container .card .card-body .preview {
  border-radius: 5px;
  background: #EDEDED;
  margin-top: 16px;
  padding: 12px;
  text-align: left;
}
.copy-or-create-container .card .card-body .preview h4 {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 12px;
}
.copy-or-create-container .card .card-body .preview ol {
  counter-reset: item;
  font-weight: 500;
  margin-bottom: 0;
  padding: 8px 12px;
}
.copy-or-create-container .card .card-body .preview ol li {
  counter-increment: item;
  display: table-row;
}
.copy-or-create-container .card .card-body .preview ol li ol li:before {
  content: counters(item, ".") " ";
}
.copy-or-create-container .card .card-body .preview ol li:before {
  content: counters(item, ".") ". ";
  display: table-cell;
  padding-right: 8px;
}
.copy-or-create-container .card .card-body .copy-btn-container {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 24px;
}
.copy-or-create-container .extra-width {
  transition: 0.2s;
  width: 60%;
}
.copy-or-create-container .less-width {
  transition: 0.2s;
  width: 30%;
}
.copy-or-create-container .separator {
  align-items: center;
  display: flex;
  font-size: 1.2rem;
  font-weight: bold;
  height: 132px;
  min-width: 61px;
}

.auto-save-bar {
  border-radius: 5px;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  background: #0669B3;
  color: white;
  font-size: 14px;
  font-weight: bold;
  height: 32px;
  margin-bottom: 16px;
  padding: 5px 0;
  text-align: center;
  transition: background-color 0.5s linear;
  z-index: 10;
}

.auto-save-bar-hidden {
  height: 32px;
  margin-bottom: 16px;
  transition: background-color 0.5s linear;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/SchoolLevelExpectations.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AALA;ECFI,kBDGsB;EACtB,yBAAA;EACA,iBAAA;AAQJ;AAPI;EACI,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AASR;AAPI;ECZA,kBDa0B;EACtB,yBDSA;ECRA,gBAAA;EACA,YAAA;AASR;AARQ;EACI,mBAAA;EACA,aAAA;EACA,gBAAA;AAUZ;AATY;EACI,eAAA;EACA,gBAAA;AAWhB;AATY;ECzBR,kBD0BkC;EACtB,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;AAWhB;AARQ;EACI,mBAAA;EACA,aAAA;EACA,yBAAA;AAUZ;AATY;EACI,eAAA;EACA,gBAAA;AAWhB;AATY;EC5CR,kBD6CkC;EACtB,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;AAWhB;AANI;ECxDA,kBDyD0B;EACtB,uBAAA;EACA,yBD9BK;EC+BL,aAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAQR;AALI;EACI,6BAAA;EACA,YAAA;AAOR;AALI;EACI,6BAAA;EACA,YAAA;AAOR;;AAHA;EACI,aAAA;EACA,yBAAA;EACA,WAAA;AAMJ;;AAHA;EACI,uBAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AAMJ;AAJI;EC1FA,mBD2F0B;EACtB,iBAAA;EACA,wCAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AAMR;AAHY;EACI,cDxEH;ECyEG,eAAA;EACA,gBAAA;EACA,mBAAA;AAKhB;AAFY;EC3GR,kBD4GkC;EACtB,yBAAA;EACA,cDlFP;ECmFO,YAAA;AAIhB;AADY;EClHR,kBDmHkC;EACtB,mBDvGR;ECwGQ,gBAAA;EACA,aAAA;EACA,gBAAA;AAGhB;AADgB;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAGpB;AAAgB;EACI,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAEpB;AAAoB;EACI,uBAAA;EACA,kBAAA;AAExB;AAA4B;EACI,gCAAA;AAEhC;AAEoB;EACI,iCAAA;EACA,mBAAA;EACA,kBAAA;AAAxB;AAIY;EACI,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AAFhB;AAOI;EACI,gBAAA;EACA,UAAA;AALR;AAOI;EACI,gBAAA;EACA,UAAA;AALR;AAOI;EACI,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AALR;;AASA;EChLI,kBDiLsB;EACtB,gBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,mBDzJS;EC0JT,YAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,wCAAA;EACA,WAAA;AANJ;;AASA;EACI,YAAA;EACA,mBAAA;EACA,wCAAA;AANJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n\n\n.sles-container {\n    @include borderRadius(5px);\n    margin: 16px 0px 32px 0px;\n    min-height: 300px;\n    .ordinal-movement-wrapper {\n        align-items: center;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n    }\n    .sle-and-children {\n        @include borderRadius(5px);\n        background-color: $grey1;\n        margin: 24px 0px;\n        padding: 4px;\n        .sle-wrapper {\n            align-items: center;\n            display: flex;\n            margin: 16px 8px;\n            label {\n                font-size: 20px;\n                font-weight: 500;\n            }\n            .sle-text-area {\n                @include borderRadius(5px);\n                font-size: 14px;\n                margin-left: 16px;\n                max-height: 80px;\n                min-height: 30px;\n                padding: 8px;\n                resize: vertical;\n                width: 90%;\n            }\n        }\n        .sle-child-wrapper {\n            align-items: center;\n            display: flex;\n            margin: 4px 39px 4px 80px;\n            label {\n                font-size: 16px;\n                font-weight: 500;\n            }\n            .sle-child-text-area {\n                @include borderRadius(5px);\n                font-size: 14px;\n                margin-left: 8px;\n                max-height: 80px;\n                padding: 8px;\n                resize: vertical;\n                width: 93%;\n            }\n\n        }\n    }\n    .icon-btn-wrapper {\n        @include borderRadius(5px);\n        align-items: flex-start;\n        background-color: $pearl-blue;\n        display: flex;\n        height: 30px;\n        margin-left: 16px;\n        padding-top: 1px;\n    }\n\n    .button-icon-right {\n        background-color: transparent;\n        border: none;\n    };\n    .button-icon {\n        background-color: transparent;\n        border: none;\n    };\n}\n\n.sle-button-wrapper {\n    display: flex;\n    justify-content: flex-end;\n    width: 100%\n}\n\n.copy-or-create-container {\n    align-items: flex-start;\n    display: flex;\n    gap: 20px;\n    justify-content: center;\n    min-height: 132px;\n    padding: 32px 20px;\n\n    .card {\n        @include borderRadius(10px);\n        background: white;\n        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n        padding: 16px;\n        text-align: center;\n        transition: 0.2s;\n        width: 45%;\n\n        .card-body {\n            .card-title {\n                color: $pearl-blue;\n                font-size: 18px;\n                font-weight: 700;\n                margin-bottom: 12px;\n            }\n\n            .form-select {\n                @include borderRadius(5px);\n                border: 1px solid $grey3;\n                color: $grey4a;\n                padding: 4px;\n            }\n\n            .preview {\n                @include borderRadius(5px);\n                background: $white;\n                margin-top: 16px;\n                padding: 12px;\n                text-align: left;\n\n                h4 {\n                    font-size: 1rem;\n                    font-weight: 700;\n                    margin-bottom: 12px;\n                }\n\n                ol {\n                    counter-reset: item;\n                    font-weight: 500;\n                    margin-bottom: 0;\n                    padding: 8px 12px;\n\n                    li {\n                        counter-increment: item;\n                        display: table-row;\n                        ol {\n                            li:before {\n                                content: counters(item, \".\") \" \";\n                            }\n                        }\n                    }\n                    li:before {\n                        content: counters(item, \".\") \". \";\n                        display: table-cell;\n                        padding-right: 8px;\n                    }\n                }\n            }\n            .copy-btn-container {\n                align-items: center;\n                display: flex;\n                justify-content: center;\n                margin-top: 24px;\n            }\n        }\n    }\n\n    .extra-width {\n        transition: 0.2s;\n        width: 60%;\n    }\n    .less-width {\n        transition: 0.2s;\n        width: 30%;\n    }\n    .separator {\n        align-items: center;\n        display: flex;\n        font-size: 1.2rem;\n        font-weight: bold;\n        height: 132px;\n        min-width: 61px;\n    }\n}\n\n.auto-save-bar {\n    @include borderRadius(5px);\n    position: sticky;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background: $pearl-blue;\n    color: white;\n    font-size: 14px;\n    font-weight: bold;\n    height: 32px;\n    margin-bottom: 16px;\n    padding: 5px 0;\n    text-align: center;\n    transition: background-color 0.5s linear;\n    z-index: 10;\n}\n\n.auto-save-bar-hidden {\n    height: 32px;\n    margin-bottom: 16px;\n    transition: background-color 0.5s linear;\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
